<script lang="ts">
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let active = false;
  export let label = "";
  export let href = "";

  function ev포커스() {
    dispatch("click");
  }

  // function ev블러() {
  //   isFocused = false;
  // }
</script>

<div class="sub_tab_item">
  <a class="sub_tab_link" class:active={active === true} {href}>
    <slot />
  </a>
</div>

<style lang="scss">
  a {
    text-decoration: none;
  }
  .sub_tab_item {
    text-align: center;
    width: 150px !important;
    height: 50px;
  }
  .sub_tab_link {
    cursor: pointer;
    display: block;
    font-weight: 200;
    position: relative;
    color: #999;
    font-size: 15px;
    letter-spacing: -0.03em;
    line-height: 34px;
    border-left: 1px solid #eee;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    background: #fff;
  }
  .active {
    border-bottom-color: #fff;
    color: #d5022b;
  }
</style>
